import React, { useState } from "react";
import { ProfileCard, EnseigneDrawer } from "@viewComponents/profile_utils";

interface Enseigne {
  id: number;
  name: string;
  sector?: string;
  chalandise?: number;
  contribution?: number;
  global_invest?: number;
  surface_min?: number;
  surface_max?: number;
  point_of_sales_count?: number;
}

interface SearchEnseignesProps {
  count: number;
  enseignes?: Enseigne[];
  message?: string;
}

export const SearchEnseignesResult: React.FC<SearchEnseignesProps> = ({
  count,
  enseignes = [],
  message,
}) => {
  const [selectedEnseigne, setSelectedEnseigne] = useState<Enseigne | null>(
    null,
  );

  if (count === 0 || message) {
    return (
      <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600">
        {message || "Aucune enseigne trouvée"}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="text-sm font-medium text-gray-700">
        {count} enseigne{count > 1 ? "s" : ""} trouvée{count > 1 ? "s" : ""}
      </div>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {enseignes.map((enseigne) => {
          // Map to ProfileCard expected format
          const mappedEnseigne = {
            id: enseigne.id,
            name: enseigne.name,
            logo_url: undefined,
            sector: enseigne.sector,
            chalandise: enseigne.chalandise,
            contribution: enseigne.contribution,
            surface_min: enseigne.surface_min,
            surface_max: enseigne.surface_max,
            surface_display:
              enseigne.surface_min && enseigne.surface_max
                ? `${enseigne.surface_min}-${enseigne.surface_max}m²`
                : enseigne.surface_min
                  ? `min ${enseigne.surface_min}m²`
                  : enseigne.surface_max
                    ? `max ${enseigne.surface_max}m²`
                    : undefined,
          };

          return (
            <ProfileCard
              key={enseigne.id}
              entity={mappedEnseigne}
              entityType="enseignes"
              onClick={() => setSelectedEnseigne(enseigne)}
              onDetailClick={() => setSelectedEnseigne(enseigne)}
            />
          );
        })}
      </div>

      {selectedEnseigne && (
        <EnseigneDrawer
          enseigne={selectedEnseigne}
          onClose={() => setSelectedEnseigne(null)}
        />
      )}
    </div>
  );
};
